import { useState } from "react";
import ImagePreviewModal from "../ImagePreviewModal";
import LazyLoadImage from "../LazyLoadImage";
import { DefaultIcon } from "@/constant/imagePath";
import { cn } from "@/utils/cn";

const ImageWithFallback = ({ url, thumbnailSrc = null, className = null }) => {
  const [modalImageUrl, setModalImageUrl] = useState(null);

  const handleOpenModal = (imageUrl) => {
    setModalImageUrl(imageUrl);
  };

  const handleCloseModal = () => {
    setModalImageUrl(null);
  };

  return url ? (
    <>
      <div
        className="relative cursor-pointer flex max-w-8 max-h-7 justify-center mx-auto"
        onClick={(e) => {
          e.stopPropagation();
          handleOpenModal(url);
        }}
      >
        <LazyLoadImage
          src={thumbnailSrc ?? url}
          alt="preview"
          placeholder={DefaultIcon}
          className={cn(className || "w-16 max-h-6 object-contain duration-500")}
        />
      </div>
      {modalImageUrl && (
        <ImagePreviewModal
          imageUrl={modalImageUrl}
          onClose={handleCloseModal}
        />
      )}
    </>
  ) : (
    "-"
  );
};

export default ImageWithFallback;
